/**
 * hs-contact-router — the contact form's topic chips.
 *
 * The chips are radio inputs named contact[Topic], so the choice submits with
 * the form and reaches the notification email with or without this script.
 * All this adds is the part that makes the control worth having: the message
 * placeholder changes with the topic, so the visitor is asked for the specific
 * thing that topic needs rather than staring at an empty box.
 *
 * Scoped to its own element — two forms on a page stay independent.
 */
class HSContactRouter extends HTMLElement {
  connectedCallback() {
    this.message = this.querySelector('[data-hs-message]');
    if (!this.message) return;

    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  onChange(event) {
    if (event.target.matches('input[type="radio"][name="contact[Topic]"]')) this.sync();
  }

  sync() {
    const checked = this.querySelector('input[type="radio"][name="contact[Topic]"]:checked');
    const placeholder = checked?.dataset.hsPlaceholder;
    if (placeholder) this.message.placeholder = placeholder;
  }
}

if (!customElements.get('hs-contact-router')) {
  customElements.define('hs-contact-router', HSContactRouter);
}
